import React from "react";

import "./Hover.css";

export function Hover() {
  return (
    <div>
      <a href="https://www.google.com">Go to Google.com</a>
      <a href="https://www.facebook.com">Go to facebook</a>
      <a href="https://www.mystarec.com/">Go to Random</a>
      <ul>
        <li>
          <i class="fas fa-quidditch"></i> Badminton
        </li>
        <li>
          <i class="fas fa-plane"></i> Travelling
        </li>
        <li>
          <i class="fas fa-utensils"></i> Briyani
        </li>
        <li>
          <i class="fas fa-baseball-ball"></i> Cricket
        </li>
        <li>
          <i class="fas fa-guitar"></i> Music
        </li>
      </ul>

      <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>

      <div>
        <p class="orange">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>
        <p class="orange">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>
        <p class="orange">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>
        <p class="orange">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>
      </div>

      <div class="container">
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>

        <section>
          <p>Grand child</p>
        </section>

        <p class="middle">Middle</p>
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iure, eum!</p>
      </div>
    </div>
  );
}
